import gql from "graphql-tag"

export class ContentManager {
  constructor(
    apolloMobileClient,
  ) {
    /** @type ApolloClient */
    this.apolloMobileClient = apolloMobileClient
  }

  async getDocuments(categories = []) {
    let variables = {}, variableDefinitions = [], conditions = [], queryArgs = [];

    for (let i=0; i<categories.length; i++) {
      const variableName = 'category' + i;
      conditions.push(`{field: categoryKey, value: $${variableName}}`)
      variables[variableName] = categories[i];
      variableDefinitions.push(`$${variableName}: String!`)
    }

    if (conditions.length) {
      queryArgs.push(`conditions: {gate: and, inputs: [`+conditions.join(',')+`]}`);
    }

    variableDefinitions = variableDefinitions.length ? `(`+variableDefinitions.join(',')+`)` : '';
    queryArgs = queryArgs.length ? `(`+queryArgs.join(',')+`)` : '';

    return this.apolloMobileClient
      .query({
        query: gql`
              query getDocuments${variableDefinitions} {
                documents${queryArgs} {
                  id
                  title
                  parts {
                    id
                    sequence
                    type
                    ... on TextPart {
                      text
                    }
                    ... on ImagePart {
                      image {
                        file {
                          id
                          hasFile
                          fileExtension
                          handlerName
                          webPath
                          mimeType
                          size
                          width
                          height
                        }
                      }
                    }
                    ... on VideoPart {
                      video {
                        file {
                          id
                          hasFile
                          fileExtension
                          handlerName
                          webPath
                          mimeType
                          size
                          width
                          height
                        }
                      }
                      poster {
                        file {
                          id
                          hasFile
                          fileExtension
                          handlerName
                          webPath
                          mimeType
                          size
                          width
                          height
                        }
                      }
                    }
                  }
                }
              }`,
        variables,
      })
      .then(result =>  result.data.documents)
  }
}
